var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settingsEmail" } }, [
    _c("div", { staticClass: "name" }, [_vm._v("Change Email")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "settings-content" },
      [
        _c("v-text-field", {
          attrs: { disabled: "" },
          model: {
            value: _vm.$store.getters.profile.email,
            callback: function($$v) {
              _vm.$set(_vm.$store.getters.profile, "email", $$v)
            },
            expression: "$store.getters.profile.email"
          }
        }),
        _vm._v(" "),
        _c("v-text-field", {
          ref: "inputEmail1",
          attrs: {
            type: "email",
            label: "New Email",
            rules: _vm.rules.email1,
            "validate-on-blur":
              _vm.$refs.inputEmail1 && _vm.$refs.inputEmail1.valid
          },
          model: {
            value: _vm.email1,
            callback: function($$v) {
              _vm.email1 = $$v
            },
            expression: "email1"
          }
        }),
        _vm._v(" "),
        _c("v-text-field", {
          ref: "inputEmail2",
          attrs: {
            type: "email",
            label: "Confirm New Email",
            rules: _vm.rules.email2,
            "validate-on-blur":
              _vm.$refs.inputEmail2 && _vm.$refs.inputEmail2.valid
          },
          model: {
            value: _vm.email2,
            callback: function($$v) {
              _vm.email2 = $$v
            },
            expression: "email2"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "buttons" },
      [
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { loading: _vm.lockout, color: "primary", flat: "" },
            on: {
              click: function($event) {
                _vm.save()
              }
            }
          },
          [_vm._v("SAVE")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "clear" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b00b068e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b00b068e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsEmail.vue
// module id = 578
// module chunks = 4